<template>
<div class="event-list">
  <p>{{ eventCount }} event(s)</p>

    <LoaderLight v-if="!events" />
    <div v-if="events" class="events-container">
      <Event :key="event.event_id" v-for="event in events" :event="event" v-show="filterEventByItems[event.event_id]" />
    </div>
</div>
</template>

<script>
import LoaderLight from "@/components/atoms/LoaderLight";
import Event from "@/components/atoms/Event";
import {
    mapState
} from "vuex";

export default {
    components: {
        LoaderLight,
        Event
    },
    props: ["events"],
    data() {
        return {
            itemPerPage: 20,
            page: 1,

        };
    },
    computed: {
        filterEventByItems() {
            let allowedEvents = {};
            if (this.events) {
            for (const event of this.events) {
                allowedEvents[event.event_id] = true;

                if (this.selectedItems.length > 0) {
                    allowedEvents[event.event_id] = false;

                    let itemIds = event.items.map((e) => e.item_id);
                    for (const item of this.selectedItems) {
                        if (itemIds.includes(item)) {
                            allowedEvents[event.event_id] = true;
                        }
                    }
                }
            }
            }

            return allowedEvents;
        },
        eventCount() {
          let counter = 0
          for (const item in this.filterEventByItems) {
            if(this.filterEventByItems[item] == true) counter += 1
          }
          return counter;
        },
        ...mapState({
            selectedItems: (state) => state.items.selectedItems,
        }),
    },
};
</script>
